/** С возвращением: офлайн-доход и серия — подключение к стору и колбэкам. */
import type { WindowProps } from "../kit";
import { WelcomeBackView } from "./view";
import { appStore, serverNow, useStore, registerWindow } from "../../../app";
import { actions } from "../actions";
import { balanceV1, seasonDaysLeft, seasonStep } from "@newfungame/engine";
import { useMemo } from "preact/hooks";
import { welcomeBackModel } from "./model";

export function WelcomeBack({ close }: WindowProps<"welcomeBack">) {
  const player = useStore(appStore, (s) => s.player);
  // данные — на момент открытия: после «Забрать всё» сервер обнулит доход, а окно уже закрыто
  const model = useMemo(() => (player ? welcomeBackModel(balanceV1, player) : null), [player === null]);
  if (!model) return null;
  const def = balanceV1.season;
  const season = player?.season ?? null;
  const goal =
    def && season && seasonStep(def, season.points) < def.steps
      ? {
          points: def.pointsPerStep - (season.points % def.pointsPerStep),
          days: seasonDaysLeft(season.endsAt, serverNow(appStore.get())),
        }
      : null;
  return (
    <WelcomeBackView
      model={model}
      seasonGoal={goal}
      onClaimAll={() => {
        actions().claimWelcomeBack({ offline: model.coins > 0, streak: model.streakClaimable });
        close();
      }}
    />
  );
}

export function register(): void {
  registerWindow("welcomeBack", WelcomeBack);
}
